import React from "react";
import Graph from "Pages/Graph";


const Graphtheme = () => {
  return (
    <React.Fragment>
        <Graph/>
    </React.Fragment>
  );
};

export default Graphtheme;
